import { LngLatBoundsLike } from 'mapbox-gl';
import { IBoundingBox, ICoordinates } from '../interfaces/geo';

export const mapboxBoundsToRutilusBounds = (bounds: any): IBoundingBox => ({
  southWest: { latitude: bounds.getSouthWest().lat, longitude: bounds.getSouthWest().lng },
  northEast: { latitude: bounds.getNorthEast().lat, longitude: bounds.getNorthEast().lng },
});

export const rutilusBoundsToMapboxBounds = (bounds: IBoundingBox): LngLatBoundsLike => {
  const southWest: [number, number] = [bounds.southWest.longitude, bounds.southWest.latitude];
  const northEast: [number, number] = [bounds.northEast.longitude, bounds.northEast.latitude];
  return [southWest, northEast];
};

// [minX, minY, maxX, maxY]
export const turfBoundsToRutilusBounds = (
  bounds: [number, number, number, number] | [number, number, number, number, number, number],
): IBoundingBox => ({
  southWest: { latitude: bounds[1], longitude: bounds[0] },
  northEast: { latitude: bounds[3], longitude: bounds[2] },
});

export const bboxCenter = (boundingBox: IBoundingBox): ICoordinates => {
  const minLng = boundingBox.southWest.longitude;
  const maxLng = boundingBox.northEast.longitude;
  const minLat = boundingBox.southWest.latitude;
  const maxLat = boundingBox.northEast.latitude;
  const centerLng = (minLng + maxLng) / 2;
  const centerLat = (minLat + maxLat) / 2;
  return { longitude: centerLng, latitude: centerLat };
};
